import { Edit, SimpleForm, useNotify, useRecordContext, useRedirect } from "react-admin";

import dataProvider from "server/dataProvider";
import BackButtonToolbar from "features/BackButtonToolbar";
import useConflictErrorModal from "server/components/Modals/useConflictErrorModal";
import { studentRequests } from "api/studentApi";
import { useNotifyError } from "utils/useNotifyError";
import PreparatoryScheduleForm from "./PreparatoryScheduleForm";

const EditPreparatoryScheduleForm = ({ onSave }) => {
  const record = useRecordContext();

  return (
    <SimpleForm onSubmit={values => onSave(record.id, values)}>
      <PreparatoryScheduleForm mode="edit" />
    </SimpleForm>
  );
};

const EditPreparatorySchedule = () => {
  const { handleConflictError, ConflictErrorDialog } = useConflictErrorModal();
  const notifyError = useNotifyError();
  const notify = useNotify();
  const redirect = useRedirect();

  // The academic year, curriculum and language identify the schedule and are immutable server-side,
  // so only the name and the discipline tree are sent.
  const handleSave = async (id, { name, disciplines }) => {
    try {
      await dataProvider.customRequest(
        studentRequests.updatePreparatorySchedule(id),
        { name, disciplines },
        "PUT",
      );
      notify("Записът е редактиран", { type: "success" });
      redirect(-1);
    } catch (err) {
      notifyError(err);
      handleConflictError(err);
    }
  };

  return (
    <>
      <Edit
        title="Редакция на разписание за подготвителна година"
        mutationMode="pessimistic"
        actions={<BackButtonToolbar />}
      >
        <EditPreparatoryScheduleForm onSave={handleSave} />
      </Edit>
      <ConflictErrorDialog />
    </>
  );
};

export default EditPreparatorySchedule;
